import schema from '../../schema/editorSchema'
import { getNewQuestionTemplateAddMedia } from '../getNewQuestionTemplate'
import { generateRandQuestionId } from '../../../utils/generateRandQuestionId'
import { uploadNewImage } from '../../../actions/mediaUpload'
import { showNotification } from '../../../actions/notifications'
import { getActiveQuestionChoiceCount } from '../getActiveQuestionChoiceCount'
import { getActiveQuestionSlideWidth } from '../getActiveQuestionSlideWidth'
import { SetAttrsStep } from '../SetAttrsStep'
import store from '../../../store'
import analytics from '../../../utils/cdpAnalytics'
import { getGifUrls, conformDeliveryUrl } from '../../../utils/mediaDeliveryUrls'
import { removeFailedMediaUploadNode } from './removeFailedMediaUploadNode'
// TODO clean up and maybe combine prompt/choice functions

function sendInsertGIFAnalytics(node, gifAttrs) {
  let isPromptMedia = false
  if (node.type.name === 'questionAnimatedGIF') {
    isPromptMedia = true
  }
  analytics.track('Insert GIF', {
    isPromptMedia,
    host: gifAttrs.host,
    title: gifAttrs.title,
    gifUrl: conformDeliveryUrl(gifAttrs.gifUrl),
  })
}

export function addQuestionAnimatedGIF(gifyID, giphyOriginalStill, giphyOriginalGifURL, giphyOriginalWebPURL, giphySlug, giphyUser, attribution, title, width, height, insertPos, questionPos, questionNode) {
  return () => {
    const { tr } = window.view.state
    const newTemplate = getNewQuestionTemplateAddMedia(questionNode.attrs.template)
    tr.setNodeMarkup(questionPos, null, { ...questionNode.attrs, template: newTemplate })
    window.view.state.doc.nodesBetween(questionPos, questionPos + questionNode.nodeSize, (node, pos) => {
      if (node.type.name === 'choiceImage' ||
        node.type.name === 'choiceVideo' ||
        node.type.name === 'choiceSound' ||
        node.type.name === 'choiceAnimatedGIF' ||
        node.type.name === 'choice') {
        tr.setNodeMarkup(pos, null, { ...node.attrs, template: newTemplate })
      }
    })

    let giphyUserObj = null
    if (giphyUser) {
      giphyUserObj = {
        username: giphyUser.username,
        profileUrl: giphyUser.profile_url,
        avatarUrl: giphyUser.avatar_url,
      }
    }
    const nowDate = new Date()

    const type = schema.nodes.questionAnimatedGIF
    const gifAttrs = {
      fileId: gifyID,
      addedAt: nowDate,
      host: 'giphy',
      attribution,
      title,
      stillUrl: conformDeliveryUrl(giphyOriginalStill),
      gifUrl: conformDeliveryUrl(giphyOriginalGifURL),
      webpUrl: conformDeliveryUrl(giphyOriginalWebPURL),
      giphySlug,
      giphyUser: giphyUserObj,
      template: newTemplate,
      dimensions: {
        w: width,
        h: height,
      },
    }

    gifAttrs.questionMediaDynamicHeight = questionNode.attrs.questionMediaDynamicHeight
    gifAttrs.slideWidth = questionNode.attrs.slideWidth
    const gifNode = type.create(gifAttrs)
    sendInsertGIFAnalytics(gifNode, gifAttrs)
    tr.replaceWith(insertPos.start, insertPos.end, gifNode)
    tr.setMeta('triggerParseDoc', true)
    window.view.dispatch(tr)
  }
}

export function uploadQuestionAnimatedGIF(insertPos, questionPos, questionNode, file) {
  return (dispatch) => {
    const { tr } = window.view.state
    const newTemplate = getNewQuestionTemplateAddMedia(questionNode.attrs.template)
    tr.setNodeMarkup(questionPos, null, { ...questionNode.attrs, template: newTemplate })

    window.view.state.doc.nodesBetween(questionPos, questionPos + questionNode.nodeSize, (node, pos) => {
      if (node.type.name === 'choiceImage' ||
        node.type.name === 'choiceVideo' ||
        node.type.name === 'choiceSound' ||
        node.type.name === 'choice') {
        tr.setNodeMarkup(pos, null, { ...node.attrs, template: newTemplate })
      }
    })
    const nodeId = generateRandQuestionId()
    const nowDate = new Date()
    const type = schema.nodes.questionAnimatedGIF

    const gifAttrs = {
      nodeId,
      addedAt: nowDate,
      // placeholder:'placeholder',
      fileId: '',
      host: 'cloudinary', // keeping this to cloudinary for data consistency for now
      stillUrl: '',
      gifUrl: '',
      webpUrl: '',
      template: newTemplate,
      dimensions: {
        w: '',
        h: '',
      },
    }

    gifAttrs.questionMediaDynamicHeight = questionNode.attrs.questionMediaDynamicHeight
    gifAttrs.slideWidth = getActiveQuestionSlideWidth()
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target.result
      img.onerror = showUnreadableGIFNotification
      img.onload = function () {
        const placeholderDimensions = {
          w: img.naturalWidth,
          h: img.naturalHeight,
        }
        gifAttrs.placeholder = event.target.result
        gifAttrs.placeholderDimensions = placeholderDimensions
        let fileName = file.name
        const extensions = ['.gif']
        extensions.forEach((extension) => {
          fileName = fileName.replace(extension, '')
        })
        gifAttrs.title = fileName
        const gifNode = type.create(gifAttrs)
        tr.replaceWith(insertPos.start, insertPos.end, gifNode)
        tr.setMeta('triggerParseDoc', true)
        window.view.dispatch(tr)
        return dispatch(beginImageUpload(event.target.result)).then((response) => {
          updateGIFNodeWithMediaUploadValues(response, nodeId)
        })
          .catch(() => removeFailedMediaUploadNode(nodeId))
      }
    }
  }
}

export function uploadChoiceAnimatedGIF(insertPos, file) {
  return (dispatch) => {
    const { tr } = window.view.state
    const nodeId = generateRandQuestionId()
    const type = schema.nodes.choiceAnimatedGIF
    const nowDate = new Date()
    const gifAttrs = {
      questionChoiceCount: getActiveQuestionChoiceCount(),
      slideWidth: getActiveQuestionSlideWidth(),
      addedAt: nowDate,
      nodeId,
      host: 'cloudinary', // keeping this to cloudinary for data consistency for now
      fileId: '',
      deliveryMediaUploadUrl: '',
      dimensions: {
        w: '',
        h: '',
      },
    }
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target.result
      img.onerror = showUnreadableGIFNotification
      img.onload = function () {
        const placeholderDimensions = {
          w: img.naturalWidth,
          h: img.naturalHeight,
        }
        gifAttrs.placeholderDimensions = placeholderDimensions
        gifAttrs.placeholder = event.target.result
        const gifNode = type.create(gifAttrs)
        tr.replaceWith(insertPos.start, insertPos.end, gifNode)
        tr.setMeta('triggerParseDoc', true)
        window.view.dispatch(tr)
        return dispatch(beginImageUpload(event.target.result)).then((response) => {
          updateGIFNodeWithMediaUploadValues(response, nodeId)
        })
          .catch(() => removeFailedMediaUploadNode(nodeId))
      }
    }
  }
}

export function updateGIFNodeWithSavedMediaUploadValues(nodeId) {
  const state = store.getState()
  if (state.imageUploads[nodeId]) {
    updateGIFNodeWithMediaUploadValues(state.imageUploads[nodeId], nodeId)
  }
}

function checkIfFileIsAnimated(mediaUploadResponse) { // animated GIF check
  let isAnimated = false
  if (mediaUploadResponse.pages && mediaUploadResponse.pages > 1) {
    isAnimated = true
  }
  return isAnimated
}

function updateGIFNodeWithMediaUploadValues(mediaUploadResponse, nodeId) {
  const { tr } = window.view.state
  let imageNode
  let imageNodePos
  window.view.state.doc.nodesBetween(0, window.view.state.doc.content.size, (node, pos) => {
    if (node.attrs.nodeId && node.attrs.nodeId === nodeId) {
      imageNodePos = pos
      imageNode = node
    }
  })

  if (imageNode) {
    const imageAttrs = { ...imageNode.attrs }
    const fileId = mediaUploadResponse.public_id
    const intrinsicHeight = mediaUploadResponse.height
    const intrinsicWidth = mediaUploadResponse.width
    // check if it is a static file and show notification
    const isAnimated = checkIfFileIsAnimated(mediaUploadResponse)
    if (!isAnimated) {
      store.dispatch(showNotification("If you'd like to insert it as an image instead, go to Insert Image.", 'Selected GIF file does not contain animation.', 'default'))
    }

    const dimensions = {
      w: intrinsicWidth,
      h: intrinsicHeight,
    }
    imageAttrs.dimensions = dimensions
    imageAttrs.fileId = fileId
    const gifUrls = getGifUrls(fileId)
    imageAttrs.stillUrl = gifUrls.stillUrl
    imageAttrs.webpUrl = gifUrls.webpUrl
    imageAttrs.gifUrl = gifUrls.gifUrl
    tr.step(new SetAttrsStep(imageNodePos, imageAttrs))
    tr.setMeta('addToHistory', false)
    tr.setMeta('triggerParseDoc', true)
    sendInsertGIFAnalytics(imageNode, imageAttrs)
    window.view.dispatch(tr)
  }
  store.dispatch({ type: 'MEDIA_UPLOAD_SUCCESS', nodeId, mediaUploadResponse })
}

// the browser could not decode the file, so no placeholder is inserted and nothing is uploaded
function showUnreadableGIFNotification() {
  store.dispatch(showNotification(" we're unable to read this GIF file. Please try a different GIF.", 'GIF upload failed:', 'destroy'))
}

function beginImageUpload(src) {
  return (dispatch) => dispatch(uploadNewImage(src)).then((response) => response)
    .catch((error) => {
      if (error.response && error.response.status === 400) {
        store.dispatch(showNotification(" we're unable to insert the GIF. Please try a different GIF.", 'GIF upload failed:', 'destroy'))
      }
      throw (error)
    })
}

export function addChoiceAnimatedGIF(gifyID, giphyOriginalStill, giphyOriginalGifURL, giphyOriginalWebPURL, giphySlug, giphyUser, attribution, title, width, height, insertPos) {
  return () => {
    const { tr } = window.view.state
    const type = schema.nodes.choiceAnimatedGIF
    let giphyUserObj = null
    if (giphyUser) {
      giphyUserObj = {
        username: giphyUser.username,
        profileUrl: giphyUser.profile_url,
        avatarUrl: giphyUser.avatar_url,
      }
    }
    const nowDate = new Date()

    const gifAttrs = {
      fileId: gifyID,
      addedAt: nowDate,
      host: 'giphy',
      questionChoiceCount: getActiveQuestionChoiceCount(),
      slideWidth: getActiveQuestionSlideWidth(),
      stillUrl: conformDeliveryUrl(giphyOriginalStill),
      gifUrl: conformDeliveryUrl(giphyOriginalGifURL),
      webpUrl: conformDeliveryUrl(giphyOriginalWebPURL),
      giphySlug,
      giphyUser: giphyUserObj,
      title,
      attribution,
      dimensions: {
        w: width,
        h: height,
      },
    }

    const gifNode = type.create(gifAttrs)
    sendInsertGIFAnalytics(gifNode, gifAttrs)
    tr.replaceWith(insertPos.start, insertPos.end, gifNode)
    tr.setMeta('triggerParseDoc', true)
    window.view.dispatch(tr)
  }
}
